import {
	Datagrid,
	EditButton,
	Filter,
	List,
	TextField,
	TextInput,
	DeleteButton,
	usePermissions,
} from "react-admin";

import { userPreferences } from "../../utils/fakeUserPrefrences";
import { constants, rolesGlobal } from "../../utils/constants";
import { CustomDeleteButtonWithCustomConfirm } from "../../customComponents/CustomButtons";

const ContentTypeFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
	</Filter>
);

export const SubContentTypeList = ({ ...props }) => {
	const { permissions, isLoading } = usePermissions();

	if (isLoading) return null;
	const hideActions = permissions?.includes(rolesGlobal.coach);

	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<ContentTypeFilter />}
			empty={false}
		>
			<Datagrid>
				{[
					...new Set([
						...userPreferences.translationLanguages,
						userPreferences.displayLanguage,
					]),
				].map((lang, index) => (
					<TextField
						key={`${lang}${index}`}
						source={`title.${lang}`}
						sortable={false}
					/>
				))}
				{hideActions === false && <EditButton />}
				{hideActions === false && <CustomDeleteButtonWithCustomConfirm mutationMode="pessimistic" />}
			</Datagrid>
		</List>
	);
};
